// Armazenamento do consentimento de cookies — desacoplado do React, pra
// poder ser lido de qualquer lugar (ex.: antes do primeiro render).
// Usa localStorage (não expira sozinho — só muda se o usuário trocar a
// preferência ou limpar os dados do navegador, ou se CONSENT_VERSION subir).

const STORAGE_KEY = "mn_cookie_consent";
const CONSENT_VERSION = 1;

/**
 * @typedef {Object} ConsentRecord
 * @property {number} version
 * @property {string} date - ISO 8601
 * @property {true} necessary - sempre true, não é desativável
 * @property {boolean} analyticsMarketing
 */

/** @returns {ConsentRecord | null} null = ainda não decidiu (ou versão antiga) */
export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

/** @param {{ analyticsMarketing: boolean }} prefs */
export function storeConsent(prefs) {
  const record = {
    version: CONSENT_VERSION,
    date: new Date().toISOString(),
    necessary: true,
    analyticsMarketing: Boolean(prefs.analyticsMarketing),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  } catch {
    // Navegador bloqueando localStorage (modo privado restrito etc.) — a
    // escolha simplesmente não persiste entre visitas; não é um erro fatal.
  }
  return record;
}

/** Helper síncrono pedido no passo 3 do prompt — usado pelos loaders de script. */
export function hasAnalyticsConsent() {
  return getStoredConsent()?.analyticsMarketing === true;
}
